import React, {Component} from 'react';
import {connect} from 'react-redux';
import $ from "jquery";
import {bindActionCreators} from 'redux';
import {withRouter} from "react-router-dom";

import {detailPolling} from "../../actions/pollingAction";
import FeedUser from "../FeedContainer/FeedUser"
import FeedMenu from "../FeedContainer/FeedMenu";
import ShareFeed from "../FeedContainer/ShareFeed";
import LinearDeterminate from "./progressbar";
import FeedFooter from "../FeedContainer/FeedFooter";
import PollingOptionDetails from "./pollingoptiondetails";
import './polling.css';
import { timingSafeEqual } from 'crypto';

class PollingDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentFeed         : {},
      toggleStatus        : '',
      toggle_feed_id      : '',
      urlFeedId           : this.props.urlFeedId, 
      currentActiveImage  : 0,
      carousalFeed        : 0
    };
    this.fetchPoll      = this.fetchPoll.bind(this);
    this.toggleFunction = this.toggleFunction.bind(this);
   
  }
  componentDidMount(){
    this.fetchPoll(this.state.urlFeedId);
  }
  

  fetchPoll(feedId){
    let param = {
      feed_id : feedId
    };
    this.props.detailPolling(param);
   
  }
  

  UNSAFE_componentWillReceiveProps(nextProps,prevProps){

    
      this.setState({
        currentFeed : nextProps.detailpoll
      });
    
    
  }
  toggleFunction(toggleFeed){
    this.setState({
      toggleStatus    : (this.state.toggleStatus == 'is-collapsed') ? '' : 'is-collapsed',
      toggle_feed_id  : toggleFeed
    });
  }
  
  render() {
    let details = this.state.currentFeed || {};
    return (
        <div className="post_box">
          <div className="center_post">
            <div className="post_header">
              {(Object.keys(details).length > 0) ?       
                <FeedUser post_user={details.post_user} post_date={details.post_date}/>
                : null
              }

              {(Object.keys(details).length > 0) ?       
                <FeedMenu 
                  feed_id       ={details.feed_id} 
                  post_id       ={details.post_id} 
                  data_type     ={details.data_type} 
                  toggle_feed_id={this.state.toggle_feed_id} 
                  toggleStatus  ={this.state.toggleStatus} 
                  toggleFunction={this.toggleFunction} 
                  logged_in_user={this.props.currentUserDetails}  
                  post_user     ={details.post_user} 
                  position      ="post"
              
                />
                : null
              }
            </div>
           
            <div className="post_body">
                <div className="polling-content"> 
                  {details.content} 
                </div>
                <PollingOptionDetails 
                  optionDetails = {details.poll_details} 
                  voteStatus = {details.poll_vote_status}
                  data_type = {details.data_type}
                  urlFeedId = {details.feed_id} 
                  post_id   = {details.post_id} 
                />    
            </div>
          </div>
          {(Object.keys(details).length > 0) ?   
            <FeedFooter 
              total_reaction  ={details.total_reaction} 
              my_reaction     ={details.my_reaction} 
              total_comment   ={details.total_comment} 
              total_share     ={details.total_share} 
              data_type       ={details.data_type} 
              feed_id         ={details.feed_id} 
              post_id         ={details.post_id}
              position        ="post" 
              feed_reaction_details = {details.feed_reaction_details} 
            />
            : null
          }
          
       </div>
 
      
    );
  }
}
const mapStateToProps = state => {
 
  return {
    detailpoll      : state.detailpoll.detailPoll,
  }
}
const mapDispatchToProps = dispatch => {
  return {
    detailPolling: bindActionCreators(detailPolling, dispatch),

  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PollingDetails));
